import { InitializedMediaDevices } from "./widgets";
import { Avatar, IconButton, styled } from "@mui/material";
import { useDebugSettings } from "../../../tools";
import { useSettings } from "../tools";
import DebugInfoPanel from "../DebugInfoPanel";
import { getNameLetters } from "../room/tools";
import { useSelectedEffectedVideoTrack, useVideoEffectManager } from "../contexts/videoEffectContext";
import { Video } from "@dvrt/web-phone-client";
import { useBoolState } from "@dvrt/react-tools";
import VideoBackgroundEffectDialog from "../video-background-effect-dialog/VideoBackgroundEffectDialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const width = 500;
const height = 250;

const Preview = styled("div")(({ theme }) => ({
    width: "fit-content",
    position: "relative",
    "&:hover .settingsButton": {
        opacity: 1,
    },
    [theme.breakpoints.down("sm")]: {
        height: "100%",
        width: "100%",
    },
}));

const VideoElement = styled(Video)(({ theme }) => ({
    maxWidth: width,
    maxHeight: height,
    transform: "scaleX(-1)",
    [theme.breakpoints.down("sm")]: {
        maxWidth: "unset",
        maxHeight: "unset",
        width: "100%",
    },
}));

const PlaceholderDiv = styled("div")({
    padding: "5em",
});

const SettingsButton = styled(IconButton)({
    opacity: 0,
    position: "absolute",
    top: 0,
    right: 0,
    margin: 5,
    transition: "opacity 0.2s",
});

const Placeholder = () => {
    const { displayName } = useSettings();
    return (
        <PlaceholderDiv>
            <Avatar style={{ fontSize: "1.1rem" }}>{getNameLetters(displayName ?? "")}</Avatar>
        </PlaceholderDiv>
    );
};

const Live = () => {
    const debugSettings = useDebugSettings();
    const track = useSelectedEffectedVideoTrack();
    const [isShowBED, showBED, hideBED] = useBoolState();
    const { available } = useVideoEffectManager();

    if (!track) return <Placeholder />;

    return (
        <>
            {available && <VideoBackgroundEffectDialog show={isShowBED} close={hideBED} />}
            <Preview>
                <VideoElement track={track} />
                {debugSettings.enabled && debugSettings.showVideoInfo && <DebugInfoPanel track={track} showEffect />}
                {available && (
                    <SettingsButton className="settingsButton" onClick={showBED} size="large">
                        <FontAwesomeIcon icon="cog" style={{ filter: "drop-shadow(0px 0px 3px black)" }} />
                    </SettingsButton>
                )}
            </Preview>
        </>
    );
};

const VideoPreview = () => {
    const settings = useSettings();

    if (!settings.video) return <Placeholder />;

    return (
        <InitializedMediaDevices placeholder={<Placeholder />}>
            <Live />
        </InitializedMediaDevices>
    );
};

export default VideoPreview;
